<script>
    export let filter;
    export let selectedFilters;
    export let computedFilters;
    $: isSelected = selectedFilters.has(filter);
    $: isIncluded = computedFilters.has(filter);
</script>

<span class="tag {isSelected ? 'selected' : isIncluded ? 'included' : ''}" on:click>
    {filter}
</span>

<style>
    .tag {
        margin-right: 5px; 
        padding:5px; 
        background-color: whitesmoke;
        font-size: 12px;
        color: rgb(170,170,170);
        display: inline-block;
    }
    .tag.selected {
        color: black;
        font-weight: bold;
    }
    .tag.included {
        color: black;
    }

    @media only screen and (max-width: 767px) {
        .tag {
            font-size: 22px;
        }
    }
</style>